import {Button} from "@mui/material";
import React, {useState} from "react";
import {Result} from "../../client/Result";
import {AlertInfo, UserAlert} from "./UserAlert";
import {styled} from '@mui/material/styles';
import {CircleAlertIcon, UploadIcon} from "../icons/Icons";
import {Link} from "react-router-dom";

interface UploadButtonProps {
    onFileUpload: (file: File) => Promise<Result<null>>
    disabled?: boolean
    formatPath?: string
    successMessage?: string
}

export const UploadButton: React.FC<UploadButtonProps> = ({onFileUpload, disabled, formatPath, successMessage}) => {
    const [showAlert, setShowAlert] = useState(false)
    const [alertInfo, setAlertInfo] = useState<AlertInfo>()
    const [inProgress, setInProgress] = useState(false)

    const uploadFile = async (file: File) => {
        const result = await onFileUpload(file)
        const alertInfo: AlertInfo = result.fold(
                () => ({message: successMessage ?? 'File uploaded successfully', type: 'success'}),
                message => ({message: message, type: 'error'})
        )
        setAlertInfo(alertInfo)
        setShowAlert(true)
    }

    const Input = styled('input')({})

    return <>
            <Button variant="contained" component="label" startIcon={<UploadIcon/>} disabled={disabled ?? inProgress} data-testid="upload-button">
                Upload File
                <Input hidden type="file" onChange={async (e) => {
                    setInProgress(true)
                    if (e.target.files != null) {
                        await uploadFile(e.target.files[0])
                        setInProgress(false)
                    }
                }}></Input>
            </Button>
        <UserAlert show={showAlert} setShow={setShowAlert} alertInfo={alertInfo}/>
        { formatPath && <Link to={formatPath}><CircleAlertIcon/>Accepted Formats</Link> }
    </>
}
